export const optionLaptime = ['オート', '5', '10', '15', '20', '25', '30', '35', '40', '45'];
